import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import { ENDPOINT_TOKEN } from '../helpers/HandleFieldChange.jsx';
import '../../styles/TextField.css';

const Disease = ({ language, value, onChange, error }) => {
  const { t } = useTranslation();
  const [diseasesData, setDiseasesData] = useState(null);

  useEffect(() => {
    const fetchDiseasesData = async () => {
      try {
        const response = await fetch(`https://vipe.uy/services/get_diseases.php`);
        const data = await response.json();
        setDiseasesData(data.content.diseases);
      } catch (error) {
        console.error('Error fetching diseases data:', error);
      }
    };

    fetchDiseasesData();
  }, []);

  const handleDiseaseChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
  };

  if (!diseasesData) {
    return <div>Loading diseases...</div>; // Muestra un indicador de carga mientras se obtiene el JSON
  }

  const sortedDiseases = [...diseasesData].sort((a, b) => {
    const diseaseA = language === 'en' ? a.en : a.es;
    const diseaseB = language === 'en' ? b.en : b.es;
    return diseaseA.localeCompare(diseaseB);
  });

  return (
    <label>
      <select
        className="textField-select-disease"
        name="diseaseName"
        value={value}
        onChange={handleDiseaseChange}
      >
        <option value="">{t('form.none')}</option>
        {sortedDiseases.map((disease, index) => (
          <option
            key={index}
            value={language === 'en' ? disease.en : disease.es}
          >
            {language === 'en' ? disease.en : disease.es}
          </option>
        ))}
      </select>
      {error && <span className="errorMessage">{error}</span>}
    </label>
  );
};

export default Disease;
